import { useIndexPrice } from './indexprice'

export function useLastPrice(ep_id: number) {
	const { data, mutate } = useIndexPrice(ep_id)
	return {
		data: data,
		mutate: mutate,
	}
}
